module.exports = __webpack_public_path__ + "32042b0248e3a380304ba0e8c01ed6e7.svg";